import { Component, OnInit, OnDestroy, HostListener, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PortsService } from './ports.service';
import { DatePicker } from './../shared/date-picker';
import { FavoriteDirective } from './../shared/directives/favorite.directive';
import { BlurComponent } from './../shared/blur';
import { LogService } from './../shared/';

declare const moment: any;

@Component({
  selector: 'ports',
  template: require('./ports.component.html'),
  styles: [require('./ports.component.scss')],
  providers: [PortsService]
})
export class PortsComponent implements OnInit, OnDestroy {

  schedules: any = {
    scheduleId: 0,
    total: 0,
    carriers: new Array<any>(),
    selectedCarriers: new Array<number>(),
    excludedCarriers: new Array<number>(),
    items: new Array<any>()
  };
  port: any = {
    display: '',
    userData: {
      favorited: false,
      note: ''
    }
  };
  portId: number;
  date: string;
  // selected: Array<number> = [];
  offset: number;
  limit: number = 20;
  sub: any;

  pages: Array<number> = [];
  pageNumber: number = 1;
  paginationContext: string = '';

  constructor(private service: PortsService, private logger: LogService, private route: ActivatedRoute, private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    this.logger.log('ports.component', 'ngOnInit', this.route.snapshot.params);
    this.sub = this.route.params.subscribe(this.setupPage.bind(this));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  ngAfterViewInit() {
    this.service.resizeSidebar()
  }

  @HostListener('window:resize', ['$event.target'])
  onResize() {
    this.service.resizeSidebar()
  }

  setupPage(params: { [key: string]: any }): void {
    this.portId = +params['id'];

    if (moment(decodeURIComponent(params['date']), 'YYYY-MM-DD').format('YYYY-MM-DD') != 'Invalid date') {
      let date = decodeURIComponent(params['date']);
      this.date = moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
    } else {
      this.date = moment().format('YYYY-MM-DD');
    }

    if ((params['selected_carriers'] != null) && (params['selected_carriers'] !== 0)) {
      this.schedules.selectedCarriers = params['selected_carriers'].split(',').map(Number);
    } else {
      this.schedules.selectedCarriers = [];
    }

    if ((params['excluded_carriers'] != null) && (params['excluded_carriers'] !== 0)) {
      this.schedules.excludedCarriers = params['excluded_carriers'].split(',').map(Number);
    } else {
      this.schedules.excludedCarriers = [];
    }

    this.limit = +params['limit'] || 20;
    this.offset = +params['offset'] || 0;

    if (params['scroll'] != null && params['scroll'] === 'true') {
      window.scrollTo(0, 0);
    }

    this.getPortSchedules();
    this.getPort();
  }

  setupPagination() {
    this.pageNumber = Math.floor(this.offset / this.limit) + 1;
    let pageTotal = Math.ceil(this.schedules.total / this.limit);
    let newPages = [];

    if (this.pages === null) {
      this.pages = [];
    } else if (pageTotal <= 9) {
      let count = 0;
      for (let current = 1; current <= pageTotal; current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    } else if (this.pageNumber <= 5) {
      this.pages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    } else if ((this.pageNumber > 5) && (this.pageNumber > pageTotal - 4)) {
      let count = 0;
      for (let current = pageTotal - 9; current <= pageTotal; current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    } else {
      let count = 0;
      for (let current = this.pageNumber - 5; (current < this.pageNumber + 4) && (current < pageTotal); current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    }

    if (this.pageNumber === pageTotal) {
      this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) + ' - ' + (this.schedules.total) + ' of ' + this.schedules.total;
    }
    else {
      this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) + ' - ' + (this.limit * this.pageNumber) + ' of ' + this.schedules.total;
    }
  }

  toPage(page: number) {
    if (page == this.pageNumber){
      // dont call update
      return;
    }
    this.service.loaderOff = false;
    this.offset = (page - 1) * this.limit;
    this.update();
  }

  selectCarrier(carrier) {
    carrier.selected = !carrier.selected;
    let excludedIndex = this.schedules.excludedCarriers.indexOf(carrier.carrier.id);
    let selectedIndex = this.schedules.selectedCarriers.indexOf(carrier.carrier.id);

    if (carrier.selected) {
      // select
      if (excludedIndex > -1) {
        this.schedules.excludedCarriers.splice(excludedIndex, 1);
      }

      if (this.schedules.selectedCarriers.length !== 0) {
        if (selectedIndex === -1) {
          this.schedules.selectedCarriers.push(carrier.carrier.id);
        }
      }
    }
    else {
      // de-select
      if (excludedIndex === -1) {
        this.schedules.excludedCarriers.push(carrier.carrier.id);
      }

      if (this.schedules.selectedCarriers.length !== 0) {
        if (selectedIndex > -1) {
          this.schedules.selectedCarriers.splice(selectedIndex, 1);
        }
      };
    }
    // // standard operating procedure
    // let index = this.schedules.excludedCarriers.indexOf(carrier.carrier.id);
    // if (index > -1) {
    //   this.schedules.excludedCarriers.splice(index, 1);
    // }
    // else {
    //   this.schedules.excludedCarriers.push(carrier.carrier.id);
    // }
    this.update();
  }

  selectAll() {
    this.schedules.selectedCarriers = [];
    this.schedules.excludedCarriers = [];

    for (let current = 0; current < this.schedules.carriers.length; current++) {
      this.schedules.carriers[current].selected = true;
      // this.schedules.selectedCarriers.push(this.schedules.carriers[current].id);
    }
    this.update();
  }

  clearAll() {
    for (let current = 0; current < this.schedules.carriers.length; current++) {
      if (this.schedules.carriers[current].selected == true) {

        let excludedIndex = this.schedules.excludedCarriers.indexOf(this.schedules.carriers[current].carrier.id);
        let selectedIndex = this.schedules.selectedCarriers.indexOf(this.schedules.carriers[current].carrier.id);

        if (excludedIndex === -1) {
          this.schedules.excludedCarriers.push(this.schedules.carriers[current].carrier.id);
        }
  
        if (this.schedules.selectedCarriers.length !== 0) {
          if (selectedIndex > -1) {
            this.schedules.selectedCarriers.splice(selectedIndex, 1);
          }
        };
      }
    }
    this.update();
  }

  allSelected() {
    var allSelected: Boolean = true;
    for (let current = 0; current < this.schedules.carriers.length; current++) {
      if (this.schedules.carriers[current].selected == false) {
        allSelected = false;
      }
    }
    return allSelected;
  }

  allCleared() {
    var allCleared: Boolean = true;
    for (let current = 0; current < this.schedules.carriers.length; current++) {
      if (this.schedules.carriers[current].selected == true) {
        allCleared = false;
      }
    }
    return allCleared;
  }

  favoritesOnly() {
    if (this.service.app.carriers.length === 0) {
      return;
    }

    try {
      this.schedules.selectedCarriers = [];
      this.schedules.excludedCarriers = [];

      for (let current = 0; current < this.schedules.carriers.length; current++) {
        if (this.schedules.carriers[current].carrier.userData.favorited) {
          this.schedules.carriers[current].selected = true;
        }
      }
      for (let current = 0; current < this.service.app.carriers.length; current++) {
        this.schedules.selectedCarriers.push(this.service.app.carriers[current].id);
      }
      this.update();
    } catch (ex) {
      // not logged in
      this.logger.log('ports.components', 'favoritesOnly catch', ex);
    }
  }

  changeDate() {
    if (this.port !== null) {
      this.update();
    }
  }

  nextDay() {
    let date = moment(this.date, 'YYYY-MM-DD').add(1, 'days');
    let ninetydays = moment().add(89, 'days');
    let minusthirtydays = moment().subtract(29, 'days');

    if (date.isAfter(ninetydays) || date.isBefore(minusthirtydays)) {
      this.service.app.showMessage('Date', 'Data limited to 90 days in the future');
      return;
    }

    if (this.port !== null) {
      this.update(date.format('YYYY-MM-DD'));
    }
  }

  previousDay() {
    let date = moment(this.date).subtract(1, 'days');
    let ninetydays = moment().add(89, 'days');
    let minusthirtydays = moment().subtract(29, 'days');

    if (date.isAfter(ninetydays) || date.isBefore(minusthirtydays)) {
      this.service.app.showMessage('Date', 'Data limited prior to 30 days in the past');
      return;
    }

    if (this.port !== null) {
      this.update(date.format('YYYY-MM-DD')); // changing date creates angular change detection error
    }
  }

  update(date = '') {
    let params = {
      date: date === '' ? this.date : date
    };

    if (this.schedules.selectedCarriers.length !== 0 && (this.schedules.selectedCarriers.length !== this.schedules.carriers.length) && (this.schedules.selectedCarriers.length !== 1 && this.schedules.selectedCarriers[0] !== 0)) {
      params['selected_carriers'] = this.schedules.selectedCarriers;
    }

    if (this.schedules.excludedCarriers.length !== 0) {
      params['excluded_carriers'] = this.schedules.excludedCarriers;
    }

    if (this.limit !== 20) {
      params['limit'] = this.limit;
    }

    if (this.offset !== 0) {
      params['offset'] = this.offset;
    }

    this.router.navigate(['/ports', this.portId, params]);
  }

  getPortSchedules(retry = true) {
    this.logger.log('ports.component', 'getPortSchedules', this.schedules.selectedCarriers);
    let params = {
      'eta.lte': this.date,
      'etd.gte': this.date
    };

    this.service.loaderOff = false;
    if (this.schedules.selectedCarriers.length !== 0) {
      params['carriers'] = this.schedules.selectedCarriers;
    }

    if (this.schedules.excludedCarriers.length !== 0) {
      params['carriers.ne'] = this.schedules.excludedCarriers;
    }

    if (this.limit !== 20) {
      params['limit'] = this.limit;
    }

    if (this.offset !== 0) {
      params['offset'] = this.offset;
    }

    this.service.getPortSchedules(this.portId, params).then(schedules => {
      if (schedules !== null) {
        this.schedules = schedules;
      }
      this.setupPagination();
    }).catch(ex => {
      if (ex === 403 && retry) {
        this.getPortSchedules(false);
      }
    });
  }

  getPort(retry = true) {
    this.service.getPort(this.portId).then(port => {
      if (port !== null) {
        this.port = port;
      }
    }).catch(ex => {
      if (ex === 403 && retry) {
        this.getPort(false);
      }
    });
  }

  public sidebarActive = false;
  slideOutIn() {
    this.sidebarActive = !this.sidebarActive;
  }

  registerMessage() {
    this.service.app.showRegister();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/ports/ports.component.ts